
	<app-header></app-header>
	<div class="page-content bg-white">
		<app-home></app-home>
	</div>
		
	<app-footer></app-footer>
	<button class="scroltop icon-up" type="button"><i class="fa fa-arrow-up"></i></button>